import { get } from "lodash"
import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "@/api/auth"
import axiosAuthRequired from "@/api/axiosAuthRequired"
import moment from "moment"

const instaproBaseUrl = `${process.env.INSTAPRO_API_URL}api/v1/`
const baseUrl = `${process.env.PROGUIDES_WEB_URL}api/v2/`

export const getInstaProAccessToken = async () => {
  // Get instapro access token
  const response = await axiosAuthRequired({
    method: "get",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/instapro/user/access-token",
    headers: getAuthHeaders(),
  })
  return get(response, "data.access_token")
}

export const getUser = async instaProToken => {
  const response = await axios({
    method: "get",
    url: process.env.INSTAPRO_API_URL + "api/v1/user",
    headers: {
      Authorization: "Bearer " + instaProToken,
    },
  })
  return get(response, "data.result")
}

export const updateUser = async (instaProToken, userData) => {
  try {
    const response = await axios({
      method: "put",
      url: process.env.INSTAPRO_API_URL + "api/v1/user",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
      data: userData,
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const postInstacoachCoachApplication = async payload => {
  const accessTokenResponse = await axiosAuthRequired({
    method: "get",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/instapro/user/access-token",
    headers: {
      Authorization:
        "Bearer " + window.localStorage.getItem("client_credentials"),
    },
  })

  const accessToken = get(accessTokenResponse, "data.access_token")
  return axios({
    method: "post",
    url: process.env.INSTAPRO_API_URL + "api/v1/coach",
    data: payload,
    headers: {
      Authorization: "Bearer " + accessToken,
    },
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getGames = async () => {
  try {
    const response = await axios({
      method: "get",
      url: process.env.PROGUIDES_WEB_URL + "api/v2/instapro/games",
    })

    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCoachUser = async coachUserId => {
  try {
    const response = await axios({
      method: "get",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach/" + coachUserId,
    })
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRecommendedCoaches = async ({ game, languages }) => {
  languages = languages || ["English"]
  try {
    let url = `${process.env.INSTAPRO_API_URL}api/v1/coach/recommended?page_size=6`
    if (game) {
      url += `&games[0]=${game}`
      languages.forEach((language, i) => {
        url += `&primary_languages[${i}]=${language}`
      })
    }
    const res = await axios({
      method: "get",
      url,
    })
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getFavoriteCoaches = async ({ instaProAccessToken }) => {
  try {
    const res = await axios({
      method: "get",
      url: `${process.env.INSTAPRO_API_URL}api/v1/student/coaches/favorited`,
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    })
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getCoachByUsername = async (username, instaProAccessToken) => {
  try {
    const url = `${process.env.INSTAPRO_API_URL}api/v1/coach/by-username/${username}`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

// We can add more param to this function to query different page and size if needed
export const getCoaches = async status => {
  try {
    let url = `${process.env.INSTAPRO_API_URL}api/v1/coach`
    const params = {
      params: {},
    }
    if (status) {
      params.params.status = status
    }
    const res = await axios.get(url, params)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getCoachReportCardById = async (id, instaProAccessToken) => {
  try {
    const url = `${instaproBaseUrl}coach/requests/${id}/report_card`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return {
      success: false,
    }
  }
}

export const getCoachRequestById = async (id, instaProAccessToken) => {
  try {
    const url = `${instaproBaseUrl}coach/requests/${id}`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return {
      success: false,
    }
  }
}

export const createReferralCodes = async instaProAccessToken => {
  try {
    const url = `${baseUrl}referral-codes/coach`
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        "Authorization": "Bearer " + clientCredentials,
        "X-INSTA-TOKEN": instaProAccessToken,
      },
    }
    const res = await axios.post(url, null, config)
    return res.data
  } catch (error) {
    console.error(error)
    return {
      status: "failure",
    }
  }
}

export const getSessionPrice = async (requestId, instaProAccessToken) => {
  try {
    const url = `${baseUrl}instapro/session-request/${requestId}/expected-price`
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        "Authorization": "Bearer " + clientCredentials,
        "X-INSTA-TOKEN": instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const getReferralStats = async (period, instaProAccessToken) => {
  try {
    const url = `${baseUrl}referral-codes/coach/stats`
    const clientCredentials = localStorage.getItem("client_credentials")
    let from
    if (period === "DAILY") {
      from = moment()
        .subtract(6, "days")
        .format("YYYY-MM-DD")
    } else if (period === "WEEKLY") {
      from = moment()
        .subtract(6, "weeks")
        .format("YYYY-MM-DD")
    } else if (period === "MONTHLY") {
      from = moment()
        .subtract(1, "years")
        .format("YYYY-MM-DD")
    }
    const config = {
      params: {
        period,
        from,
      },
      headers: {
        "Authorization": "Bearer " + clientCredentials,
        "X-INSTA-TOKEN": instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getSessionRequests = async (type, status, instaProAccessToken) => {
  try {
    const url = `${instaproBaseUrl}student/requests`
    const config = {
      params: {
        type,
        status,
      },
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const searchCoachesForGame = async (
  instaProAccessToken,
  gameId,
  page,
  sort,
  appliedTaxonomies,
  search,
  filters
) => {
  try {
    const params = {
      page,
      sort,
      search: search || null,
      page_size: 24,
    }
    let index = 0
    for (let taxonomy of appliedTaxonomies) {
      for (let option of taxonomy) {
        params[`categories[${index}][category]`] = option.category
        params[`categories[${index}][taxonomy_type]`] = option.taxonomy_type
        params[`categories[${index}][taxonomy]`] = option.taxonomy
        index++
      }
    }
    if (filters) {
      index = 0
      for (let filter of filters) {
        params[`filters[${index}]`] = filter
        index++
      }
    }
    const config = {
      params,
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const url = `${instaproBaseUrl}student/games/${gameId}/coaches`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const favoriteCoach = async (coachId, instaProAccessToken) => {
  try {
    const url = `${instaproBaseUrl}student/follow`
    const url2 = `${instaproBaseUrl}student/favorite`
    const body = {
      id: coachId,
    }
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    await axios.post(url, body, config)
    const res = await axios.post(url2, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const unfavoriteCoach = async (coachId, instaProAccessToken) => {
  try {
    const url = `${instaproBaseUrl}student/favorite`
    const url2 = `${instaproBaseUrl}student/follow`
    const body = {
      id: coachId,
    }
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    await axios.post(url, body, config)
    const res = await axios.post(url2, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getCoachReviews = async (coachId, instaProAccessToken, page) => {
  try {
    const url = `${instaproBaseUrl}coach/${coachId}/ratings`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
      params: {
        page,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getCoachSubscriptions = async coachId => {
  try {
    const url = `${baseUrl}instapro/coach/${coachId}/coach-subs`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const requestSession = async (body, instaproToken) => {
  try {
    const url = `${baseUrl}instapro/session-request`
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        "Authorization": "Bearer " + clientCredentials,
        "X-INSTA-TOKEN": instaproToken,
      },
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return Promise.reject(error)
  }
}

export const submitSessionReview = async (requestId, body, instaproToken) => {
  try {
    const url = `${instaproBaseUrl}student/requests/${requestId}/rate`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.put(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response.data
  }
}

export const submitEffectivenessReview = async (
  requestId,
  body,
  instaproToken
) => {
  try {
    const url = `${instaproBaseUrl}student/requests/${requestId}/rate-coach-effectiveness`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response.data
  }
}



// WEBPACK FOOTER //
// ./src/api/coaching.js